<template>
    <ui-crud title="Keys" subtitle="Track who has possession of what keys." :fetch="fetch">

        <!-- Filters. -->
        <template #filters="{ debouncedRefresh }">
            <div class="relative">
                <ui-input class="mt-6" field="bg-gray-50 pr-10" name="search" v-model="search" @input="debouncedRefresh()"></ui-input>
                <div class="absolute right-0 inset-y-0 h-full flex items-center justify-center p-3 text-gray-400">
                    <i class="fas fa-search"></i>
                </div>
            </div>
        </template>

        <!-- List item. -->
        <template #list-item="{ item, select, active }">
            <ui-crud-card
                :title="item.name"
                :subtitle="[item.in_use ? `Assigned to ${item.in_use_by} on ${item.in_use_at}` : 'Not In Use']"
                :metadata="item.reference"
                :active="active"
                @click="select()"
            ></ui-crud-card>
        </template>

        <!-- Create form. -->
        <template #create="{ addItem }">
            <assets-keys-form :add-item="addItem"></assets-keys-form>
        </template>

        <!-- Edit form. -->
        <template #edit="{ selectedItem, setEditMode }">
            <assets-keys-form :item="selectedItem" :edit="setEditMode"></assets-keys-form>
        </template>

        <!-- Show page. -->
        <template #show="{ selectedItem, setEditMode, removeItem }">
            <assets-keys-show :item="selectedItem" :edit="setEditMode" :removeItem="removeItem"></assets-keys-show>
        </template>
    </ui-crud>
</template>

<script>
import { Key } from '@models'

export default {
    data () {
        return {
            search: '',
        }
    },
    methods: {
        async fetch () {
            return await Key.all(this.search)
        },
    }
}
</script>
